import { AbpOAuthService } from '@abp/ng.oauth';
import { DOCUMENT } from '@angular/common';
import { Component, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  environmentURL = environment;
  baseEnvURL: any;


  protected readonly window = inject(DOCUMENT).defaultView;

  constructor(public readonly abpOauthService: AbpOAuthService,
    private readonly sanitizer: DomSanitizer
  ) { }


  ngOnInit() {
    this.baseEnvURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.environmentURL.logoutURL);

    this.window.addEventListener('storage', event => {
      if (event.key === 'access_token' && event.newValue === null) {
        this.window.location.reload();
      }
    });
    window.addEventListener('message', this.handleWindowMessage.bind(this));
 
  }

  handleWindowMessage(event: MessageEvent) {
    if (event.data === "logout") {
      this.logout();
    }
  }

  logout() {
    this.abpOauthService.logout()
  }

}